module.exports = {
  title: '平台子账号设置',
  route: {
    path: '/admin-power-manage',
    children: {
      path: 'power-subaccount-form',
    },
  },
};
